// Derives LoyaltyServiceContext from useTeam state.
// Returns null when bunker is not connected (cannot sign events).

import { useMemo } from 'react'
import { useTeam } from '@/state/useTeam'
import type { LoyaltyServiceContext } from '@/services/loyalty'

export function useLoyaltyContext(): LoyaltyServiceContext | null {
  const { restaurantPubkey, bunkerConnected, signAsRestaurant } = useTeam()

  // Memoize so the returned object keeps a stable identity across renders.
  // Without this, every render produces a new object, which churns the
  // identity of any useCallback/useEffect that depends on it — e.g.
  // CustomerListPage's fetch effect, which would loop infinitely (#47).
  return useMemo(() => {
    if (!restaurantPubkey || !bunkerConnected) return null
    return {
      restaurantPubkey,
      signAsRestaurant,
    }
  }, [restaurantPubkey, bunkerConnected, signAsRestaurant])
}
